let CONTROL_CENTER_URL,postUrl,PAY_FOR_URL,dinghuoUrl,SJT_URL

if (process.env.VUE_APP_DEV_DOMAIN) {
  // 测试环境
  CONTROL_CENTER_URL = 'https://apscmcentertest.51autoshop.com';
  PAY_FOR_URL = 'https://apscmpaytest.eshop1001.cn/api';
  postUrl = 'https://testcarshopordershelperapi.51autoshop.com/api/';
  dinghuoUrl = 'https://apscmorderh5applet.51autoshop.com/dinghuoh5';
  SJT_URL = 'https://Apdbapi.51autoshop.com/api/';
  // UAT环境
  // CONTROL_CENTER_URL = 'https://apscmcenter.eshop1001.cn'
  // PAY_FOR_URL = 'https://apscmpaytest.eshop1001.cn/api'
  // postUrl = 'https://testcarshopordershelperapi.51autoshop.com/api/';

} else {
  // 生成环境
  CONTROL_CENTER_URL = 'https://apscmcenter.eshop1001.cn';
  PAY_FOR_URL = 'https://apscmpaythrid.eshop1001.cn/api';
  postUrl = 'https://carshopOrdersHelperapi.51autoshop.com/api/';
  dinghuoUrl = 'https://apscmorderApplet.51autoshop.com/dinghuoh5';
  SJT_URL = 'https://Apdbapi.51autoshop.com/api/'
}


export default { 
  postUrl,//老板活动
  CONTROL_CENTER_URL, // 控制中心
  PAY_FOR_URL, //支付中心
  dinghuoUrl, //订货h5域名
  SJT_URL //获取vin码
}